import styled from 'styled-components';

const Wrapper = styled.div`
    padding-block: 40px;
    // padding-inline: 15px;
    // min-width: 224px;
    border-right: 2px solid #F4F5F7;
    background-color: #22292F;
    position: relative;
    // top: 73.48px;
    height: 100vh;
    transition: all .5s ease;
    // overflow-x: hidden;
`;

export default Wrapper;